module.exports = __webpack_public_path__ + "img/nissi_D_s.bc9c05bb.png";